import React from "react";

import Heading from "@common/components/Heading/Heading";
import Paragraph from "@common/components/Paragraph/Paragraph";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";

export default function MttrAboutView() {
  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          About
        </Heading>
        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          What it measures
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {"Mean time to resolve — the average duration between a defect being created and that defect being closed."}
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          Why it matters
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "Two teams can have identical Resolution rates but very different user impact. The team that closes bugs and crashes in 4 hours protects users; the team that closes them in 4 weeks has shipped a broken product to thousands of sessions in between. MTTR is the speed dimension Resolution rate misses."
          }
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          How to use it
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "Watch how MTTR moves over time — a rising average usually signals a process bottleneck (triage delay, on-call gap, single point of failure on engineering) rather than a coding problem. If Resolution rate looks healthy but MTTR is high, your team is closing defects at the right pace but not fast enough."
          }
        </Paragraph>
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}
